import React from 'react'

import './styles.scss'
import GearButton from './GearButton'
import CheckField from '../CheckField'
import { lang } from 'utils/helpers'

const sortTypeField = {
  asc: 'down',
  desc: 'up'
}

const TableHeader = props => {
  const {
    id, colsToShow, fieldsColumns, onChange, isCheckAll,
    actionResultCheck, toggleOrder, active, sortType, originType
  } = props

  const columnsHeader = () => {
    const column = []

    for(let col of colsToShow) {
      const columnIndex = colsToShow.findIndex(colToShow => colToShow === col)
      const columnFields = fieldsColumns.find(({ value }) => value === col)
      const columnName = lang(columnFields.key).toUpperCase()

      column.push(
        <th
          key={col}
          title={columnName}
          className={`tableHeader`}
          style={{
            width: columnFields?.width || null,
            paddingRight: columnIndex !== colsToShow?.length - 1 ? '10px' : null,
            textAlign: columnFields?.centered ? 'center' : null
          }}
        >
          <div className={`tableHeaderLabel`} onClick={() => toggleOrder(col)}>
            {columnName}
            {active === col && <i className={`fa fa-sort-${sortTypeField[sortType]} pl-1`} />}
          </div>
        </th>
      )
    }

    return column
  }

  return (
    <thead id={id} className='new_thead_filter'>
      <tr
        id={`${id}__cells-container`}
        style={{
          width: (colsToShow.length <=7 || fieldsColumns.every(fieldsColumn => fieldsColumn.width))
            ? '100%'
            : `${colsToShow.length * 15}%`,
          backgroundColor: '#ffffff'
        }}
      >
        <th className={`tableHeader`} style={{ width:'40px', padding:'7px 10px', border:0 }}>
          <GearButton fields={fieldsColumns} onChange={onChange} />
        </th>
        {originType === 'conversations' ? (
          <th className={`tableHeader`} style={{ width:'40px', padding:'7px 10px' }}>
            <CheckField action={(value) => actionResultCheck(value, '', true)} isChecked={isCheckAll} />
          </th>
        ) : null}
        {columnsHeader()}
      </tr>
    </thead>
  )
}

export default TableHeader
